import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Container = styled.div`
	background: white;
	border-radius: 2px;
	box-shadow: 0 2px 3px 0 rgba(0,0,0,0.2);
	transform: translateY(0px);
	transition: all 0.3s ease-out;

	display: flex;
	flex-direction: ${props => props.theme.type === 'list' ? 'row' : 'column'};
	justify-content: ${props => props.theme.type === 'list' ? 'space-between' : 'initial'};

	transform: ${props => props.new ? 'scale(0)' : 'none'};
	transform-origin: 50% 50%;
	animation: ${props => props.new ? 'new 0.2s ease-out 0s 1 normal forwards running' : 'none'};
	width: ${props => props.theme.type === 'list' ? '100%' : '350px'};
	margin: ${props => props.theme.type === 'list' ? '0 0 16px 0' : '0 40px 40px 0'};

	&:hover {
		transform: translateY(-3px);
		box-shadow: 0px 8px 24px -8px rgba(60,60,60,0.3);
	}

	@keyframes new {
		to {
			transform: scale(1);
		}
	}
`;

const Details = styled(Link)`
	display: ${props => props.theme.type === 'list' ? 'flex' : 'block'};
	flex-grow: 1;
	padding: ${props => props.theme.type === 'list' ? '24px' : '24px 24px 40px'};
	color: ${props => props.theme.heading};
	text-decoration: none;
`;

const Client = styled.span`
	font-size: 24px;
	margin: ${props => props.theme.type === 'list' ? '0' : '0 0 16px'};
	display: inline-block;
`;

const Specs = styled.span`
	display: flex;
	flex-grow: 1;
	align-items: center;
	justify-content: ${props => props.theme.type === 'list' ? 'space-evenly' : 'space-between'};
	margin-bottom: 0.2rem;
`;

const Spec = styled.span`
	font-size: 14px;

	&:nth-child(2) {
		justify-self: end;
	}
`;

const Footer = styled.div`
	background-color: ${props => props.theme.type === 'list' ? 'rgba(0,0,0,0)' : 'rgba(188,197,214,0.05)'};
	padding: ${props => props.theme.type === 'list' ? '0' : '24px'};
	display: ${props => props.theme.type === 'list' ? 'flex' : 'block'};
	justify-content: ${props => props.theme.type === 'list' ? 'space-between' : 'initial'};
	${props => props.fromCollection ? 'width: 30%;' : '' }

	& ${Spec} {
		color: #6480B0;
		font-size: 12px;
		margin-top: 5px;
	}
`;
const Actions = styled.div`
	background-color: ${props => props.theme.type === 'list' ? 'rgba(188,197,214,0.05)' : 'rgba(188,197,214,0)'};
	margin: ${props => props.theme.type === 'list' ? '0' : '24px 0 0'};
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-evenly;
	padding: ${props => props.theme.type === 'list' ? '24px' : '0'};
	width: ${props => props.theme.type === 'list' ? '300px' : 'auto'};
`;

const Master = styled.span`
	background-color: ${props => props.theme.main};
	color: white;
	font-size: 12px;
	padding: 4px 6px;
	border-radius: 4px;
	display: inline-block;
	margin-right: 8px;
	transform: translateY(-4px);
`;

const Default = styled.span`
	background-color: orange;
	color: white;
	font-size: 12px;
	padding: 4px 6px;
	border-radius: 4px;
	display: inline-block;
	margin-right: 8px;
	transform: translateY(-4px);
`;

export {
	Container,
	Details,
	Client,
	Specs,
	Spec,
	Footer,
	Actions,
	Master,
	Default,
}
